import { get } from 'svelte/store';
import { ApiTypes } from '../../enums/api.enum';
import {
  addApiError,
  addBusyApi,
  removeBusyApi,
} from '../../helpers/handle-api';
import type { IAnswer } from '../../interfaces/answer.interface';
import { ConfigStore } from '../../store/config';
import { state_apiErrors } from '../../store/state';
import { defaultLogger as logger } from '../../telemetry/logger';
import { trackedFetch } from '../../telemetry/tracked-fetch';
import type { IStreamQuestion } from 'src/lib/interfaces/stream-question.interface';

/** function to fetch GET /1/question/${answer.question_id}/completion` api end point */
export async function GetQuestionRelatedSuggestions(
  answer: { question_id: string },
  isForGreeting: boolean,
  signal: AbortSignal,
  wasRetried: boolean
): Promise<any> {
  return new Promise((resolve) =>
    setTimeout(async () => {
      let responseValue;

      try {
        addBusyApi(ApiTypes.getQuestionRelatedSuggestions);
        state_apiErrors.set(
          get(state_apiErrors).filter(
            (x) => x.apiType !== ApiTypes.getQuestionRelatedSuggestions
          )
        );

        let url = new URL(
          `${get(ConfigStore).apiBaseUrl}/1/question/${answer.question_id}/completion`
        );

        if (isForGreeting && get(ConfigStore).suggestGreetingsPrompt) {
          url.searchParams.set('filter', get(ConfigStore).suggestGreetingsPrompt as string);
        } else {
          url.searchParams.set('filter', get(ConfigStore).suggestQuestionsPrompt);
        }
        let configTenantId = get(ConfigStore)?.serverConfig?.tenant_id;
        if (!!configTenantId) url.searchParams.set('tenant', configTenantId);
        let configServerId = get(ConfigStore)?.serverConfig?.id;
        if (!!configServerId) url.searchParams.set('config', configServerId);

        responseValue = trackedFetch(configTenantId ?? '', url.href, {
          method: 'GET',
          signal,
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(async (res) => {
            if (res.ok) return res;
          })
          .catch((res) => {
            if (res?.status === 404 && !wasRetried) {
              /*logger.warn(
                `Retrying POST /1/question/${answer.question_id}/completion after 404`
              );
              return await GetQuestionRelatedSuggestions(answer, signal, true);*/
              return new Promise(resolve => 
                    setTimeout(async () => {
                        logger.info(`Retrying POST /1/question/${answer.question_id}/completion after 404`);
                        const value = await GetQuestionRelatedSuggestions(answer, isForGreeting, signal, true);
                        resolve(value);
                      }, 500
                    ));
            } else {
              /** error api */
              addApiError({
                apiType: ApiTypes.getQuestionRelatedSuggestions,
                status: res?.status,
                statusText: res?.statusText,
                errorType: res?.type,
              });

              throw res;
            }
          })
          .finally(() => {
            removeBusyApi(ApiTypes.getQuestionRelatedSuggestions);
          });
      } catch (e) {
        removeBusyApi(ApiTypes.getQuestionRelatedSuggestions);
        throw e;
      }
      resolve(responseValue);
    }, 750)
  );
}
